import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CardLayoutComponent, CardField } from '../shared/card-layout/card-layout.component';
import { FormattedValuePipe } from '../shared/pipes/formatted-value.pipe';
import { globalMessages } from '../shared/global-messages';

@Component({
    selector: 'app-policy-general-information',
    imports: [CardLayoutComponent],
    template: `
        <app-card-layout
            (click)="isActive = !isActive"
            [isActive]="isActive"
            title="Policy Snapshot"
            icon="policy-status"
            subtitle="Policy general information"
            [isLoading]="isDCPolicyLoaded"
            [failed]="dcPolicyFailed"
            [fields]="fields"
            (retry)="retry.emit()"
        ></app-card-layout>
    `,
})
export class PolicyGeneralInformationComponent {
    isActive = false;
    @Input() isDCPolicyLoaded = false;
    @Input() dcPolicyFailed = false;
    @Output() retry = new EventEmitter<void>();
    private store = inject(Store);
    private formattedValuePipe = new FormattedValuePipe();

    policySignal = this.store.selectSignal((state: any) => state.policy);

    private getStatusTagTheme(status: string): string {
        switch (status?.toLowerCase()) {
            case 'inforce':
                return 'neutralAq';
            case 'new':
                return 'neutralPurple';
            case 'expired':
                return 'default';
            case 'cancelled':
                return 'default';
            case 'cancel-pending':
                return 'neutralAq';
            case 'nonrenewed':
                return 'default';
            default:
                return 'default';
        }
    }

    get fields(): CardField[] {
        const policyState = this.policySignal();
        const policyNum = policyState.policyNumber;
        const data = policyState.data?.[policyNum]?.policySnapshot?.policyGeneralInformation;
        if (!data) return [];

        const keyOrder = [
            'policyNumber',
            'policyStatus',
            'effectiveDate',
            'expirationDate',
            'insuranceScoreTier',
            'propertyFullAddress',
            'monthlyPremium',
            'annualPremium',
            'lineOfBusiness',
            'occupancy',
            'term',
        ];

        const ordered = [
            ...keyOrder.filter((key) => data[key] != null).map((key) => data[key]),
            ...Object.keys(data)
                .filter((key) => !keyOrder.includes(key))
                .map((key) => data[key]),
        ];

        return ordered
            .filter((item: any) => globalMessages.policySnapshotFields.includes(item.node))
            .map((item: any) => {
                const isStatus = item.node?.toLowerCase().includes('status');
                return {
                    caption: item.node,
                    value: this.formattedValuePipe.transform(item.value, item.node) || '',
                    isTag: isStatus,
                    tagTheme: isStatus ? this.getStatusTagTheme(item.value) : undefined,
                };
            });
    }
}
